import { useMutation, useQuery } from '@tanstack/react-query';
import {
	createSecurityRankDefinition,
	deleteRank,
	deleteSecurityRank,
	getPersonSecurityDefinitionRanks,
	getPersonSecuritiesWithFeaturesAndRanks,
	updateSecurityRankDefinition,
	upsertSecurityRank,
	upsertSecurityIncomeRanks,
	deleteSecurityIncomeRanks,
} from '@dealstack/frontend/shared/dataExchange/services/securities.ts';

export const useSecurityRankingController = (personId: string | undefined, splitIds?: string[]) => {
	const getRankingSecurities = useQuery({
		queryKey: ['personSecurityRanking', personId, splitIds],
		queryFn: () => getPersonSecuritiesWithFeaturesAndRanks(personId || '', splitIds),
		enabled: !!personId,
	});
	const getPersonRanksRequest = useQuery({
		queryKey: ['personRanks', personId],
		queryFn: () => getPersonSecurityDefinitionRanks(personId || ''),
		enabled: !!personId,
	});
	const createRankRequest = useMutation({
		mutationFn: createSecurityRankDefinition,
	});
	const updateRankRequest = useMutation({
		mutationFn: updateSecurityRankDefinition,
	});
	const deleteRankRequest = useMutation({
		mutationFn: deleteRank,
	});
	const upsertSecurityRankRequest = useMutation({
		mutationFn: upsertSecurityRank,
	});
	const upsertSecurityIncomeRanksRequest = useMutation({
		mutationFn: upsertSecurityIncomeRanks,
	});
	const deleteSecurityRankRequest = useMutation({
		mutationFn: deleteSecurityRank,
	});
	const deleteSecurityIncomeRanksRequest = useMutation({
		mutationFn: deleteSecurityIncomeRanks,
	});

	return {
		personSecurities: getRankingSecurities.data || [],
		personRanks: getPersonRanksRequest.data || [],
		personRanksLoading: getPersonRanksRequest.isPending,
		personSecuritiesUpdatedAt: getRankingSecurities.dataUpdatedAt,
		personRanksUpdatedAt: getPersonRanksRequest.dataUpdatedAt,
		refetchPersonRanks: getPersonRanksRequest.refetch,
		refetchPersonSecurities: getRankingSecurities.refetch,
		createRankRequest,
		updateRankRequest,
		deleteRankRequest,
		upsertSecurityRankRequest,
		upsertSecurityIncomeRanksRequest,
		deleteSecurityRankRequest,
		deleteSecurityIncomeRanksRequest,
	};
};
